import { Formik } from 'formik'
import React, { useEffect, useState, useRef } from 'react'
import StepItem from '../../molecules/StepItem/StepItem'
import BozzaDigitale from './Steps/BozzaDigitale/BozzaDigitale'
import IndirizzoSpedizioneFatturazione from './Steps/IndirizzoSpedizioneFatturazione/IndirizzoSpedizioneFatturazione'
import ModalitaPagamento from './Steps/ModalitaPagamento/ModalitaPagamento'
import { api } from '../../../utils'
import {
  MODALITA_SPEDIZIONE,
  ORDINI,
  REGISTRAZIONECHECK,
  REGISTRAZIONESG,
  SETSISTEMAPAGAMENTOUTENTE,
} from '../../../utils/endpoint'
import _ from 'lodash'
import useTrans from '../../../hooks/useTrans'
import useLocalStorage from '../../../hooks/useLocalStorage'
import { useRouter } from 'next/router'
import { handleScrollRef } from '../../../utils/safe'
import * as Sentry from '@sentry/browser'
import { getValidationSchema } from './validationSchema'
import {
  getTipologieUtenteRegistrazione,
  isGuestAllowed,
  isStepRequired,
} from '../../../utils/servicegift'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import TipologiaUtente from '../FormRegistrazioneSg/steps/TipologiaUtente/TipologiaUtente'
import Credenziali from '../FormRegistrazioneSg/steps/Credenziali/Credenziali'
import usePrivacy from '../../../hooks/usePrivacy'
import {
  getDataCheckRegistrazioneSg,
  getDataOrdineSg,
  getDataRegistrazioneSg,
} from '../../../utils/registrazioneSg'
import NoteOrdine from './Steps/NoteOrdine/NoteOrdine'
import InfoGenerali from './Steps/InfoGenerali/InfoGenerali'
import DatiSpedizioneFatturazione from './Steps/DatiSpedizioneFatturazione/DatiSpedizioneFatturazione'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const FormCheckoutSg = ({
  pushPayload,
  service_gift,
  carrello_main,
  setIsSubmit,
  promoCodeErrorMessage,
  promoCodeAlertMessage,
}) => {
  const t = useTrans()
  const router = useRouter()

  const { utente } = useSelector((state) => state.utente)
  const [tipologiaUtenteChiave, setTipologiaUtenteChiave] = useState(
    utente ? utente.tipologia : getTipologieUtenteRegistrazione(service_gift)?.[0]?.chiave
  )
  const [modalitaSpedizione, setModalitaSpedizione] = useState()
  const guest = (isGuestAllowed(service_gift) && router.query.guest) || false
  const isMerceNeutra = carrello_main.personalizzazioni_carrello?.length > 0 ? false : true
  const checkoutRapido = carrello_main.tipologia === 'PREVENTIVO'
  const step_modalita_pagamento = service_gift ? (!isMerceNeutra ? 3 : 2) : !isMerceNeutra ? 4 : 3
  const [valori_iniziali, setValoriIniziali] = useLocalStorage('VALORI_INIZIALI_SPLIT_CHECKOUT')
  const [step, setStep] = useState(0)
  const [splitCheckout, setSplitCheckout] = useState(null)
  const [errors, setErrors] = useState([])

  const indirizzoSpedizioneItemRef = useRef()
  const carrello_main_id = carrello_main.id

  const validationSchema = getValidationSchema(tipologiaUtenteChiave, isMerceNeutra, guest)
  const { getUrlCondizioniGenerali } = usePrivacy()

  const visibileSteps = useMemo(() => {
    return [
      'tipologia',
      'credenziali',
      'info_generali',
      'dati_fatturazione_spedizione',
      'note_ordine',
      'bozza_digitale',
      'pagamento',
    ].filter((x) =>
      isStepRequired(service_gift, tipologiaUtenteChiave, 'checkout', x, utente, isMerceNeutra)
    )
  }, [service_gift, tipologiaUtenteChiave])

  const stepsDetails = {
    tipologia: {
      placeholder: t('Tipologia di utente'),
      component: TipologiaUtente,
      props: {
        setTipologiaUtente: setTipologiaUtenteChiave,
      },
    },
    credenziali: {
      placeholder: t('Informazioni personali'),
      component: Credenziali,
      props: {
        variant: 'checkout',
        getUrlCondizioniGenerali: getUrlCondizioniGenerali,
        withAutorizzazioni: isStepRequired(
          service_gift,
          tipologiaUtenteChiave,
          'checkout',
          'autorizzazioni'
        ),
      },
    },
    info_generali: {
      placeholder: t('Informazioni generali'),
      component: InfoGenerali,
      props: {},
    },
    dati_fatturazione_spedizione: {
      placeholder: t('Opzioni di consegna e fatturazione'),
      component: !utente ? DatiSpedizioneFatturazione : IndirizzoSpedizioneFatturazione,
      props: {
        service_gift: service_gift,
        carrello_main: carrello_main,
        handleScroll: () => handleScrollRef(indirizzoSpedizioneItemRef),
        variant: 'checkout',
      },
    },
    note_ordine: {
      placeholder: t('Note ordine e istruzioni sulla consegna'),
      component: NoteOrdine,
      props: {},
    },
    bozza_digitale: {
      placeholder: t("Bozza dell'ordine"),
      component: BozzaDigitale,
      props: {
        carrello_main: carrello_main,
      },
    },
    pagamento: {
      placeholder: t('Pagamento'),
      component: ModalitaPagamento,
      props: {
        carrello_main: carrello_main,
      },
    },
  }

  useEffect(() => {
    if (carrello_main?.ordine?.carrello) {
      if (valori_iniziali) {
        setSplitCheckout({ ...valori_iniziali })
        setStep(visibileSteps.length - 1)
      }
    }
  }, [])

  useEffect(() => {
    pushPayload(null)
  }, [step])

  const RenderStep = ({ props }) => {
    return (
      <>
        {visibileSteps.map((stepChiave, i) => {
          const FormComponent = stepsDetails[stepChiave].component
          const componentProps = stepsDetails[stepChiave].props
          return (
            <StepItem
              key={`step-${tipologiaUtenteChiave}-${stepChiave}`}
              stepNumber={i + 1}
              placeholder={stepsDetails[stepChiave].placeholder}
              setStep={setStep}
              Modificabile={step > i ? true : false}
              isDisabled={step < i ? true : false}
              open={step === i ? true : false}
            >
              <FormComponent
                step={step}
                setStep={setStep}
                props={props}
                {...componentProps}
                social={false}
                Submit={() => props.handleSubmit()}
              />
            </StepItem>
          )
        })}
      </>
    )
  }

  useEffect(() => {
    api
      .get(MODALITA_SPEDIZIONE, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => setModalitaSpedizione(res.data.find((tipo) => tipo.modalita === 'Spedizione')))
  }, [])

  const handleCheckRegistrazione = async (values) => {
    try {
      // se utente non vuole creare account
      if (!values.with_registrazione) {
        return true
      }

      const params = getDataCheckRegistrazioneSg(values)
      const response = await api.get(REGISTRAZIONECHECK, { params })
      const data = await response.data

      const { exists_email, exists_piva, exists_username } = data

      setErrors([
        ...(exists_email ? [t('Esiste già un account con la stessa Email')] : []),
        ...(exists_piva ? [t('Esiste già un account con la stessa Partita Iva')] : []),
        ...(exists_username ? [t('Esiste già un account lo username indicato')] : []),
      ])

      if (!exists_email && !exists_username && !exists_piva) {
        return true
      }
    } catch (error) {
      console.log(error)
    }

    return false
  }

  const handleSubmitRegistrazione = async (values) => {
    setIsSubmit(true)

    try {
      const isValidRegistrazione = await handleCheckRegistrazione(values)
      if (isValidRegistrazione) {
        const params = getDataRegistrazioneSg(values)
        const response = await api.post(
          `${REGISTRAZIONESG}?lang=${router.locale}${
            guest
              ? values.with_registrazione
                ? '&guest=true&with-registrazione=true'
                : '&guest=true'
              : ''
          }`,
          params
        )
        const data = await response.data
        return data
      }
    } catch (error) {
      console.log(error)
    }

    setIsSubmit(false)
    return null
  }

  const handleSetSistemaPagamentoPredefinito = (values, setFieldValue) => {
    if (
      values.id_modalita_pagamento_predefinita &&
      values.utente.sistema_pagamento != values.id_modalita_pagamento
    ) {
      api
        .post(SETSISTEMAPAGAMENTOUTENTE, { sistema_pagamento: values.id_modalita_pagamento })
        .then(() => {
          if (setFieldValue) {
            const updatedUtente = {
              ...(values.utente || {}),
              sistema_pagamento: values.id_modalita_pagamento,
            }
            setFieldValue('utente', updatedUtente)
          }
        })
        .catch((error) => console.log(error))
    }
  }

  const handleSubmitOrdine = async (
    values,
    indirizzoRegistrazione,
    indirizzoFatturazioneRegistrazione
  ) => {
    const carrelloId = checkoutRapido ? checkoutRapido?.id?.toString() : carrello_main_id
    const params = getDataOrdineSg(
      values,
      carrelloId,
      indirizzoRegistrazione,
      indirizzoFatturazioneRegistrazione
    )

    // ! Inserire il pushPayload con la risposta
    setIsSubmit(true)
    return api
      .post(ORDINI, params, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => {
        pushPayload(res.data)
        setIsSubmit(false)
      })
      .catch((err) => {
        console.log(err.message)
        setIsSubmit(false)
        Sentry.captureException(err)
        router.push('/cart')
      })
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={
        splitCheckout
          ? { ...valori_iniziali, initialData: true }
          : {
              utente: guest
                ? {
                    tipologia: tipologiaUtenteChiave,
                    email: null,
                    nome: null,
                    cognome: null,
                    telefono: null,
                    username: null,
                    password: null,
                    conferma_password: null,
                    guest: true,
                  }
                : utente,
              with_registrazione: false,
              indirizzi_predefiniti: false,
              dati_indirizzo: {},
              dati_indirizzo_spedizione: {},
              indirizzi_diversi: isStepRequired(
                service_gift,
                tipologiaUtenteChiave,
                'checkout',
                'indirizzi_diversi'
              ),
              fattura_richiesta: isStepRequired(
                service_gift,
                tipologiaUtenteChiave,
                'checkout',
                'fattura_richiesta'
              ),
              is_fatturazione_italia: false,
              is_spedizione_italia: false,
              tipo_spedizione: 'corriere_sipec',
              tipo_spedizione_id: modalitaSpedizione?.id,
              indirizzo: null,
              indirizzo_fatturazione: null,
              documento_trasporto: 'ts',
              id_modalita_pagamento: null,
              id_modalita_pagamento_predefinita: null,
              codice_sconto: '',
              carrello_main_id: carrello_main_id,
              autorizzazioni: {
                privacy: true,
                privacy_commerciale: false,
              },
            }
      }
      onSubmit={async (values, formikHelpers) => {
        try {
          setValoriIniziali(values)
          let registrazioneOk = true
          let indirizzoRegistrazione = null
          let indirizzoFatturazioneRegistrazione = null
          if (guest) {
            const registrazioneData = await handleSubmitRegistrazione(values)
            registrazioneOk = registrazioneData?.success || false
            indirizzoRegistrazione = registrazioneData?.indirizzo
            indirizzoFatturazioneRegistrazione = registrazioneData?.indirizzo_fatturazione
          }
          if (registrazioneOk) {
            handleSetSistemaPagamentoPredefinito(values, formikHelpers.setFieldValue)
            await handleSubmitOrdine(
              values,
              indirizzoRegistrazione,
              indirizzoFatturazioneRegistrazione
            )
          }
        } catch (error) {
          console.log(error)
          Sentry.captureException(error)
          setIsSubmit(false)
        }
      }}
      validationSchema={validationSchema}
    >
      {(props) => (
        <div>
          <RenderStep
            setIsSubmit={setIsSubmit}
            props={props}
            service_gift={service_gift}
            isMerceNeutra={isMerceNeutra}
            carrello_main={carrello_main}
          />
          <>
            {errors.map((erorr, index) => (
              <div
                style={{ color: 'red', fontSize: 14, marginTop: 10, marginBottom: 10 }}
                key={index + '_error'}
              >
                <p>{erorr}</p>
              </div>
            ))}
          </>

          {process.env.NODE_ENV == 'development' && (
            <>
              {/* <button onClick={() => setMerceNeutra(!isMerceNeutra)}>
              {isMerceNeutra ? 'Disattiva' : 'Attiva'} il "Solo Merce Neutra" [Fini di Test]
            </button> */}
              <br />
              <button type="submit" onClick={() => console.log(props.values)}>
                Controlla payload
              </button>
              <br />
              <button type="submit" onClick={() => props.handleSubmit()}>
                Prova un Submit
              </button>
              <p style={{ color: 'red', marginTop: 20 }}>
                <strong>{JSON.stringify(props.errors, null, 2)}</strong>
              </p>
            </>
          )}
        </div>
      )}
    </Formik>
  )
}

export default FormCheckoutSg
